import React from 'react';
import Header2 from './../components/Header/Header2';
import Welcome2 from './../components/Welcome/Welcome2';
import Welcome3 from './../components/Welcome/Welcome3';
// import About1 from './../components/About/About1';
import Service2 from './../components/Service/Service2';
import Portfolio2 from './../components/Portfolio/Portfolio2';
// import Blogs2 from './../components/Blogs/Blogs2';
// import Clients from './../components/Clients';
// import Contact2 from './../components/Contact/Contact2';
// import Newsletter2 from './../components/Newsletter/Newsletter2';
// import Map from './../components/Map';
import Footer2 from './../components/Footer/Footer6';
import SimpleSlider2 from './../components/Sliders/Slick-slider2'
import bg_vide from './../videos/bigway.mp4'
function Home2() {
  return (
    <>
      <style>{`
        .home2-page .block {
          padding-top: 48px !important;
          padding-bottom: 26px !important;
        }

        .home2-page .section-block-title {
          padding-top: 48px !important;
        }

        .home2-page .section-sub-title .head-title {
          padding-bottom: 22px !important;
          margin-bottom: 22px !important;
        }

        .home2-page .section-sub-title .section-title-body .head-text {
          margin-bottom: 18px !important;
        }

        .home2-page .section-title .section-title-body,
        .home2-page .section-title-body {
          padding-bottom: 24px !important;
        }

        .home2-page .block-feature-icon {
          margin-bottom: 24px !important;
          min-height: 92px !important;
        }

        .home2-page .block-feature-icon .block-title h4 {
          margin-bottom: 10px !important;
        }

        .home2-page .h50,
        .home2-page .clearfix.h50 {
          height: 18px !important;
        }

        .home2-page .carousel-with-dots.gap-30 {
          margin-top: 0 !important;
          margin-bottom: 0 !important;
        }

        .home2-page .fog-action-buttons {
          margin-top: 22px !important;
        }

        @media (max-width: 768px) {
          .home2-page .block {
            padding-top: 30px !important;
            padding-bottom: 18px !important;
          }

          .home2-page .section-block-title {
            padding-top: 30px !important;
          }

          .home2-page .section-sub-title .head-title {
            padding-bottom: 14px !important;
            margin-bottom: 14px !important;
          }

          .home2-page .section-sub-title .section-title-body .head-text {
            margin-bottom: 12px !important;
          }

          .home2-page .section-title .section-title-body,
          .home2-page .section-title-body {
            padding-bottom: 14px !important;
          }

          .home2-page .block-feature-icon {
            margin-bottom: 16px !important;
            min-height: 78px !important;
          }

          .home2-page .h50,
          .home2-page .clearfix.h50 {
            height: 10px !important;
          }

          .home2-page .fog-action-buttons {
            margin-top: 16px !important;
          }

          .block.color-scheme-1 .section-title-body .head-title,
          #services .section-title-body .head-title,
          #portfolio .section-title-body .head-title {
            font-size: 24px !important;
            line-height: 1.1 !important;
          }

          .block.color-scheme-1 .section-title-body .head-text,
          #portfolio .feature p {
            font-size: 13px !important;
            line-height: 1.4 !important;
          }

          #services .block-feature-icon .block-title h4,
          #portfolio .feature .head-title {
            font-size: 14px !important;
            line-height: 1.25 !important;
          }

          #services .block-feature-icon .block-title p,
          #portfolio .image-overlay-content h4,
          #portfolio .image-overlay-content p {
            font-size: 13px !important;
            line-height: 1.4 !important;
          }
        }
      `}</style>
      <div className="home2-page">
        <div  id="home" className="full-screen-block viewport-video-page"> 
          <video
            autoPlay
            loop
            muted
            playsInline
            disablePictureInPicture
            disableRemotePlayback
            className="bg_video"
            onContextMenu={(e) => e.preventDefault()}
          >
                  <source src={bg_vide} type="video/mp4"></source>
          </video> 
          
          <Header2/>
          <SimpleSlider2/>
        </div>
        <Welcome2/>
        <Service2/>
        <Welcome3/>
        <Portfolio2/> 
        {/* <About1/> */}
        
        {/* <Newsletter2/> */}
        {/* <Blogs2/>
        <Clients/>
        <Contact2/>
        <Map/>  */}
        <Footer2/>
      </div>
    </>  
  );
}

export default Home2;
